import { useRef, useState, useEffect } from 'react';

const isMouseEvent = (e) => ["mouseup", "mousedown"].includes(e.type);
const isTouchEvent = (e) => ["touchstart", "touchend"].includes(e.type);
const isStartEvent = (e) => ["touchstart", "mousedown"].includes(e.type) && !!e.target;
const isEndEvent = (e) => ["touchend", "mouseup"].includes(e.type) && !!e.target;
const isEventInside = (containerRef, e) => {
  var _a;
  return (_a = containerRef.current) == null ? void 0 : _a.contains(e.target);
};
function useClickOutside(containerRef, onClickOutside) {
  const isTouch = useRef(false);
  const [isStartEventInside, setStartEventInside] = useState(false);
  const events = ["touchstart", "touchend", "mousedown", "mouseup"];
  useEffect(() => {
    events.forEach((e) => document.addEventListener(e, handler, true));
    return () => {
      events.forEach((e) => document.removeEventListener(e, handler, true));
    };
  });
  function handler(e) {
    isTouch.current = isTouchEvent(e);
    if (isMouseEvent(e) && isTouch.current) {
      return;
    }
    if (isStartEvent(e)) {
      setStartEventInside(isEventInside(containerRef, e));
    }
    if (isEndEvent(e) && !isEventInside(containerRef, e) && !isStartEventInside) {
      onClickOutside(e);
    }
  }
}

export { useClickOutside as default };
//# sourceMappingURL=useClickOutside.js.map
